const posts = [
    {
    title: "ShipShare is the Best Shipping Platform!",
    post: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
    author:
        {
            name: "Joe Doe",
        },
    date: new Date("2021-08-01"),
    image: "https://source.unsplash.com/random",
    viewsNumber: 8820,
    comments: [
        {
            user:{
                name: "Kelly Doe",
                picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
            },
            date: new Date("2021-08-01"),
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        },
        {
            user:{
                name: "Jelly Cat",
                picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg"
            },
            date: new Date("2021-08-01"),
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        },
        {
            user:{
                name: "Nelly Watt",
                picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg"
            },
            date: new Date("2021-08-01"),
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        },
        {
            user:{
                name: "Billy Cat",
                picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg"
            },
            date: new Date("2021-08-01"),
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        },
        {
            user:{
                name: "Nick Cat",
                picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg"
            },
            date: new Date("2021-08-01"),
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        },
        {
            user:{
                name: "Moon Cat",
                picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg"
            },
            date: new Date("2021-08-01"),
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        },
        ]
    },

    {
        title: "ShipShare is the Best Shipping Platform!",
        post: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        author:
            {
                name: "Joe Doe",
            },
        date: new Date("2021-08-01"),
        image: "https://source.unsplash.com/random",
        viewsNumber: 8820,
        comments: [
            {
                user:{
                    name: "Kelly Doe",
                    avatar: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                },
                date: new Date("2021-08-01"),
                content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
            },
            {
                user:{
                    name: "Jelly Cat",
                    picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg"
                },
                date: new Date("2021-08-01"),
                content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
            },
        ]
    },
    {
        title: "ShipShare is the Best Shipping Platform!",
        post: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
        author:
            {
                name: "Joe Doe",
            },
        date: new Date("2021-08-01"),
        image: "https://source.unsplash.com/random",
        viewsNumber: 8820,
        comments: [
            {
                user:{
                    name: "Kelly Doe",
                    avatar: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                },
                date: new Date("2021-08-01"),
                content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
            },
            {
                user:{
                    name: "Jelly Cat",
                    picture: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg"
                },
                date: new Date("2021-08-01"),
                content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit...",
            },
        ]
    },
];

export default posts;